import {svgIconWrapper} from '../svg-icon-wrapper';

import GoogleRegular from './google-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <GoogleRegular {...props} />;
}

SvgComponent.iconName = 'googleRegular';

export const GoogleRegularIcon = svgIconWrapper(SvgComponent);
